import styled from "styled-components/macro";

export const Container = styled.div`
  height: 50px;
  @media (min-width: 992px) {
    height: 60px;
  }
`;

export const ContainerIconText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 1.7rem 1rem 1.7rem;
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0 0 7.7rem;
    height: 50vh;
  }
`;
export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  margin-bottom: 2rem;
  @media (min-width: 992px) {
    margin-bottom: 0;
    justify-content: space-between;
    align-items: start;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding-right: 1rem;
  h4 {
    margin: 0 0 0.5rem 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: start;
    color: #000000;
  }

  @media (min-width: 992px) {
    padding-right: ${({ text }) => (text === 3 ? "6rem" : "0.5rem")};
    margin-right: 1rem;

    h4 {
      font-size: 16px;
      line-height: 18px;
    }
  }
`;
export const Text = styled.p`
  margin: 0;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: start;
  color: #000000;
  transform: ${({ scroll }) =>
    scroll > 300 ? "translateX(0)" : "translateX(-400px)"};
  transition: transform 0.5s ease-in-out;
  @media (min-width: 992px) {
    font-size: 14px;
    line-height: 20px;
    transform: ${({ scroll }) =>
      scroll > 300 ? "translateX(0)" : "translateX(-90rem)"};
  }
`;

export const SvgIcon = styled.svg`
  width: 30px;
  height: 36px;

  transform: ${({ scroll }) =>
    scroll > 300 ? "translate(0)" : "translate(16rem,2rem)"};
  transition: transform 0.7s ease-in-out;
  @media (min-width: 992px) {
    height: 40px;
    width: 40px;
    margin: 0;
    transform: ${({ scroll }) =>
      scroll > 300 ? "translate(0,0)" : "translate(22rem,8rem)"};
  }
`;
export const IconContainer = styled.div`
  margin-right: 1rem;
`;
export const Blur = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ openMenu }) =>
    openMenu ? "rgba(42, 42, 42, 0.8)" : "transparent"};
  backdrop-filter: ${({ openMenu }) => (openMenu ? "blur(10px)" : "blur(0)")};

  z-index: ${({ openMenu }) => (openMenu ? "999" : "0")};
  @media (min-width: 992px) {
    display: none;
  }
`;
